import React from 'react'

export const TeaserFirmSkeleton: React.FC = () => (
  <div className="relative flex flex-col lg:min-h-full lg:w-[16.5rem] w-full rounded-xl hover:-translate-y-1 shadow-md hover:shadow-lg transition-all duration-300 ease-in-out overflow-hidden">
    <div className="h-32 bg-gray-300 animate-pulse" />
    <div className="absolute w-24 h-24 p-4 bg-gray-300 shadow top-16 left-8 rounded-xl animate-pulse" />
    <div className="relative flex flex-col justify-between gap-2 mb-4 ml-5 mt-9 grow">
      <div className="w-20 h-5 mt-2 text-lg font-bold bg-gray-300 grow animate-pulse rounded-xl" />
      <div className="flex flex-col flex-wrap gap-4 pt-1 pb-3 text-gray-700 animate-pulse">
        <div className="flex flex-row items-center gap-1">
          <div className="w-5 h-5 bg-gray-300 animate-pulse rounded-xl" />
          <div className="w-20 h-5 text-sm leading-6 align-bottom bg-gray-300 animate-pulse rounded-xl" />
        </div>
        <div className="flex flex-row items-center">
          <div className="flex flex-row items-center gap-1">
            <div className="w-5 h-5 bg-gray-300 animate-pulse rounded-xl" />
            <div className="w-20 h-5 text-sm leading-6 align-bottom bg-gray-300 animate-pulse rounded-xl" />
          </div>
        </div>
      </div>
      <div className="w-20 h-5 text-sm bg-gray-300 animate-pulse rounded-xl" />
    </div>
  </div>
)

